import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=3046096d&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
import style0 from "./Settings.vue?vue&type=style&index=0&id=3046096d&prod&lang=sass&scoped=true"
import style1 from "./Settings.vue?vue&type=style&index=1&id=3046096d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046096d",
  null
  
)

export default component.exports